var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"ma-0",attrs:{"height":"2"},model:{value:(_vm.percent),callback:function ($$v) {_vm.percent=$$v},expression:"percent"}})}
var staticRenderFns = []

export { render, staticRenderFns }